import BarogoNotice from '@/entity/BarogoNotice';
import { barogoNoticeService } from '@/services/barogo-notice';
import { defineStore } from 'pinia';
import { computed, ref, } from 'vue';
import { pageSizeEnum } from '@/constants/pageSizeOptionList';
/** 초기화 되지 않는 데이터 */
export const prevData = {
    pageSizeType: '',
    pageNumber: 0,
};
// 바로고 공지사항
export const piniaBarogoNotice = defineStore('barogoNotice', () => {
    // state
    /** 상세정보 */
    const itemDetail = ref(new BarogoNotice());
    /** 검색 */
    const filterOption = ref({
        pageSizeType: pageSizeEnum['50'],
        pageNumber: 1,
    });
    /** 리스트 */
    const itemList = ref([]);
    /** 페이지네이션 */
    const paginationData = ref({});
    /** 게시글 수 */
    const noticeTotalCount = computed(() => paginationData.value.total || 0);
    /**
     * 리스트 조회
     */
    const getItemList = async () => {
        const response = await barogoNoticeService.getItemList({
            pageNumber: filterOption.value.pageNumber,
            pageSize: filterOption.value.pageSizeType,
        });
        itemList.value = response.list;
        paginationData.value = response.paginationData;
    };
    /**
   * 단건 조회
   */
    const getItem = async (id) => {
        const response = await barogoNoticeService.getItem(id);
        itemDetail.value = response;
        return response;
    };
    /**
     * 단건 초기화
     */
    const clear = () => {
        itemDetail.value = new BarogoNotice();
    };
    return {
        filterOption,
        itemList,
        itemDetail,
        paginationData,
        getItemList,
        getItem,
        clear,
        noticeTotalCount,
    };
});
